import React, { useEffect } from 'react';
import { Card } from 'primereact/card';
import PublicPageLayout from '@/Themes/Default/Layouts/PublicPageLayout';
import { isAuthenticated } from '@/Helpers/auth';
import PageLayout from '@/Themes/Default/Layouts/PageLayout';
import {Link} from "react-router-dom";

/**
 * Site's terms & conditions page
 */
const TermsConditionsPage = () => {
    useEffect(() => {
        document.title = 'Terms of Use' + ' · ' + document.title;
    }, []);

    const pageContent = (
        <div className="footer-pages in-height">
            <h1>Terms of Use</h1>
            <p></p>

            <h2>1. Credit Hire Platform</h2>
            <p></p>

            <p>
                &emsp;<b>1.1</b> By logging into, accessing or using the <b>Nightingale</b> for the purpose of a strategic review of a credit hire payment pack, (the <b>"Platform"</b>), you accept the following terms and conditions of use (<b>“Terms”</b>) on behalf of the organisation on whose behalf the login details
                was issued to you to access and use some element of the Platform (a <b>“User”</b>).
            </p>
            <p>
                &emsp;<b>1.2</b> Please read these Terms carefully. By accessing or using the Platform, you agree you accept and agree to abide by these Terms. If you do not accept or agree to the Terms do not use the Platform in any way.
            </p>
            <p>
                &emsp;<b>1.3</b> These Terms form a legal agreement between:
            </p>
            <p className="ml-5">
                <b>1.3.1</b> DAC Beachcroft Claims Limited (number 04218278) on its own behalf and where applicable on behalf of other members of the{' '}
                <a href="https://www.dacbeachcroft.com/en/mx/about/dac-beachcroft-group/" target="_blank">
                    DAC Beachcroft Group
                </a>{' '}
                (hereafter <b>“DAC Beachcroft”</b> or <b>"we"</b> or <b>"our"</b>) and;
            </p>
            <p className="ml-5">
                <b>1.3.2</b> the person or organisation (if any) on whose behalf the login details was issued to you to access or use the Platform (<b>"you"</b> or <b>“your”</b>).
            </p>
            <p>
                &emsp;<b>1.4</b> When you are accessing or using the Platform in your capacity as an employee, director, officer, partner, consultant or agent of a corporate or unincorporated entity or of any other person, you represent that
            </p>
            <p className="ml-5">
                <b>(i)</b> you are authorised to accept these Terms on behalf of such entity or other person within the scope and capacity of your engagement with them; and
            </p>
            <p className="ml-5">
                <b>(ii)</b> you are not using or accessing the Platform as a consumer (as defined in applicable legislation);
            </p>
            <p>
                &emsp;<b>1.5</b> No other express or implied terms will apply to the use or access to the Platform unless expressly agreed and signed in writing by a duly authorised officer of DAC Beachcroft.
            </p>
            <p>
                &emsp;<b>1.6</b> We may update the Terms from time to time without notice. You will be prompted to accept any updated Terms to continue using the Platform.
            </p>
            <p></p>

            <h2>2. About Us </h2>
            <p></p>

            <p>
                &emsp;<b>2.1</b> The Platform is jointly owned by DAC Beachcroft and Bridgetech Automotive Limited (company number 11822325) (hereafter “Bridgetech”).
            </p>
            <p>
                &emsp;<b>2.2</b> You acknowledge that:
            </p>
            <p className="ml-5">
                <b>2.2.1</b> the Platform supports and facilitates the delivery of:
            </p>
            <p className="ml-5 pl-5">
                <b>2.2.1.1</b> assessment of a credit hire invoice packs (<b>“Credit Hire Services”</b>) provided by DAC Beachcroft and/or
            </p>
            <p className="ml-5 pl-5">
                <b>2.2.1.2</b> legal services arising from and supported by a separate letter of engagement or specific agreement with DAC Beachcroft, encompassing legal advice, consultation and any associated legal activity offered (<b>“Legal Services”</b>) to clients of DAC Beachcroft.
            </p>
            <p className="ml-5">
                <b>2.2.2</b> access to or use of the Platform does not create or constitute acceptance by DAC Beachcroft of you as a client to which a solicitor-client relationship would be deemed to arise, or commit or oblige DAC Beachcroft to enter into any separate arrangement(s) with you.
            </p>
            <p className="ml-5">
                <b>2.2.3</b> to the fullest extent permitted by law these Terms relate solely to your use of the Platform not the Credit Hire Services or Legal Services which may be supported by the Platform.
            </p>
            <p>
                &emsp;<b>2.3</b> For the purpose of these Terms, <b>"Intellectual Property Rights"</b> means any and all copyright, rights in inventions, patents, know-how, trade secrets, trademarks and trade names, service marks, design rights, rights in get-up, database rights and rights in data, semiconductor chip
                topography rights, rights in software, the right to sue for passing off, mask works, utility models, domain names and all similar rights and, in each case: (1) whether registered or not; (2) including any applications to protect or register such rights; (3) including all renewals and extensions of such
                rights or applications; (4) whether vested, contingent or future; and/or (5) wherever existing.
            </p>
            <p>
                &emsp;<b>2.4</b> All Intellectual Property Rights in the Platform and/or the Materials (as defined in Clause 3 of the Terms) is owned by DAC Beachcroft and Bridgetech (referred to together as <b>"us"</b> or <b>"Intellectual Property Right Owners"</b> <b>"(IPRO)"</b>) respectively or jointly or DAC
                Beachcroft and Bridgetech have the relevant permission/consent to use Intellectual Property Rights in the Platform. You acknowledge and confirm that ownership of the Platform including all Intellectual Property Rights in the Platform and/or the Materials remains vested in and under the control of the
                respective owners of the Intellectual Property Rights and no licences or rights are granted other than to the extent set out in these Terms.
            </p>
            <p>
                &emsp;<b>2.5</b> You acknowledge and understand that the Platform contains confidential and proprietary information and you shall not conceal, modify, remove, destroy or alter in any way any proprietary markings of the IPRO on or in the Platform or any related information uploaded by any other party or
                User.
            </p>
            <p>
                &emsp;<b>2.6</b> You further acknowledge that the rights of the IPRO in the Platform sought to be protected by these Terms are unique and that breach of these Terms is likely to cause irreparable and unquantifiable damage and you agree that the IPRO may at their individual discretion apply for and
                obtain (without prejudice to any rights the IPRO may have to obtain damages) injunctive or other equitable relief without proof of damage.
            </p>
            <p>
                &emsp;<b>2.7</b> You agree that you shall be responsible for any breach of any of these Terms by you or by any of your authorised persons and you will indemnify and keep indemnified and hold harmless DAC Beachcroft and Bridgetech from and against any losses, damages, liability, costs (including legal
                fees), expenses, claims, actions, proceedings, damages, fines, penalties, and loss of profit (including any consequential, direct, indirect, special, incidental or punitive damages or loss or any other form of economic loss) however arising out of or in connection with these Terms or the unauthorised
                disclosure or use of the Platform by you or by any of your authorised persons. You acknowledge that DAC Beachcroft and Bridgetech may each bring separate causes of action arising from, or in relation to, breach of their respective Intellectual Property Rights. In addition to this, Bridgetech shall have
                the right to enforce these indemnities directly against you (and at its own capacity as a third-party beneficiary of this clause).
            </p>
            <p>
                &emsp;<b>2.8</b> You agree that if User acts outside of the directions of the person or organisation (if any) on whose behalf the login details was issued to access or use the Platform, whether during or after their employment, you will assume full responsibility for indemnifying and holding harmless
                DAC Beachcroft and/or Bridgetech according to clause 2.7 of these Terms.
            </p>
            <p>
                &emsp;<b>2.9</b> Where you upload, input, cause or permit any data to be entered into the Platform (an “Upload”) directly or indirectly you provide us with a non-exclusive royalty free licence to use such Upload as required within the Platform and agree that we may transfer such Upload to any additional
                DAC Beachcroft and/or Bridgetech system as we deem necessary to support the development, provision or availability of the Platform or the associated Credit Hire Services or Legal Services we have agreed to provide to you.
            </p>
            <p></p>

            <h2>3. Purpose of the Platform</h2>
            <p></p>

            <p>
                &emsp;<b>3.1</b> The Platform provides a strategic review of a credit hire payment pack, produces an offer and proposes a defence strategy for Users. You may only use the Platform for the Permitted Purpose which may include but is not limited to one or more of the following services:
            </p>
            <p className="ml-5">
                <b>3.1.1</b> to obtain a strategic review of a credit hire payments pack;
            </p>
            <p className="ml-5">
                <b>3.1.2</b> to process payment packs and generate the offer;
            </p>
            <p className="ml-5">
                <b>3.1.3</b> precedent bank of documents, a defence strategy or such communications in writing as occur within the Platform (the <b>“Materials”</b>);
            </p>
            <p className="ml-5">
                <b>3.1.4</b> uploading, accessing, reviewing or downloading an Upload;
            </p>
            <p>
                &emsp;<b>3.2</b> The availability of any part of the Credit Hire Services through the Platform is not guaranteed and nothing in these Terms shall be deemed to indicate the scope or functionality of any of the Credit Hire Services available.
            </p>
            <p>
                &emsp;<b>3.3</b> Subject to these Terms and the level of access we have agreed you may have to the Platform functions, you may use the Platform to make use of the specified Credit Hire Services and/or Legal Services (<b>Services</b>), for the purposes accepted by us and set out in the clause 3.1 or
                agreed separately (the <b>"Permitted Purpose"</b>). You will not access the Platform for any reason other than the Permitted Purpose.
            </p>
            <p>
                &emsp;<b>3.4</b> You acknowledge and agree that:
            </p>
            <p className="ml-5">
                <b>3.4.1</b> use of or access to the Platform does not by default create a solicitor-client relationship or constitute legal advice;
            </p>
            <p className="ml-5">
                <b>3.4.2</b> the Platform may be used to support the provision of Legal Services pursuant to a separate agreement with you;
            </p>
            <p className="ml-5">
                <b>3.4.3</b> a solicitor-client relationship is subject to our specific agreement to act for you, a separate letter of engagement or similar terms relating to that relationship and your compliance with such terms as we agree with you;
            </p>
            <p className="ml-5">
                <b>3.4.4</b> access to and use of the Platform is only intended within the scope of the Services, territories and jurisdictions we confirm the Platform can be used for.
            </p>
            <p></p>

            <h2>4. Accessing the Platform</h2>
            <p></p>

            <p>
                &emsp;<b>4.1</b> Access to and use of the Platform is:
            </p>
            <p className="ml-5">
                <b>4.1.1</b> solely for the Permitted Purpose; and
            </p>
            <p className="ml-5">
                <b>4.1.2</b> only for those we have agreed may have access to or use of the Platform; and
            </p>
            <p className="ml-5">
                <b>4.1.3</b> subject always to the continued compliance with these Terms and such other provisions notified to you from time to time.
            </p>
            <p>
                &emsp;<b>4.2</b> Access to, and use of, the Platform by you is subject to the continued acceptance by DAC Beachcroft at its sole discretion, which may be refused, restricted, suspended or withdrawn at any time for any duration without prior notice for:
            </p>
            <p className="ml-5">
                <b>4.2.1</b> breach of these Terms;
            </p>
            <p className="ml-5">
                <b>4.2.2</b> breach of any terms or special terms agreed between DAC Beachcroft and you;
            </p>
            <p className="ml-5">
                <b>4.2.3</b> using or attempting to use any element of the Platform beyond the Permitted Purpose;
            </p>
            <p className="ml-5">
                <b>4.2.4</b> breach of any additional terms, requirements or restrictions concerning use of the Platform;
            </p>
            <p className="ml-5">
                <b>4.2.5</b> continued compliance with legal or regulatory requirements;
            </p>
            <p className="ml-5">
                <b>4.2.6</b> any reason that DAC Beachcroft believes is necessary and commercially appropriate at its sole discretion.
            </p>
            <p>
                &emsp;<b>4.3</b> You are responsible for keeping your login and password confidential and for all activity on the Platform enabled by access using that login and password.
            </p>
            <p>
                &emsp;<b>4.4</b> You shall not permit any other person to use your login and password to gain access to the Platform. You shall immediately notify DAC Beachcroft of any actual or suspected unauthorised use of your login or password or suspected breach of the security of the Platform. Neither DAC
                Beachcroft, nor its professional advisers, subsidiaries, directors, employees or agents of DAC Beachcroft shall have any liability to you or to any other person for any loss or damage which occurs as a result of your breach of this paragraph.
            </p>
            <p>
                &emsp;<b>4.5</b> You acknowledge that Bridgetech is not a party to this agreement, but you further recognise that any breach of your obligations under these Terms could cause Bridgetech substantial harm or loss. By accepting these Terms, you agree to hold Bridgetech harmless and indemnify it according
                to clause 4.6 of these Terms.
            </p>
            <p>
                &emsp;<b>4.6</b> You shall indemnify DAC Beachcroft and/or Bridgetech and hold them harmless on demand from and against any and all losses, claims, damages, costs, charges, expenses, liabilities, demands, proceedings and actions which DAC Beachcroft and/or Bridgetech may sustain or incur or which may be
                brought or established against DAC Beachcroft and/or Bridgetech by any person which arise out of or in relation to:
            </p>
            <p className="ml-5">
                <b>4.6.1</b> any breach of the DAC Beachcroft's and/or Bridgetech's Intellectual Property Rights by you, including but not limited to unauthorised use or disclosure of proprietary information, trademarks, copyright or any other intellectual property owned by DAC Beachcroft and/or Bridgetech.
            </p>
            <p className="ml-5">
                <b>4.6.2</b> any breach of your obligations under these Terms by you, including but not limited to non-compliance with these Terms, unauthorised or improper use of the Platform, engaging in any activity that may harm the reputation, goodwill or interests of DAC Beachcroft and/or Bridgetech.
            </p>
            <p className="ml-5">
                <b>4.6.3</b> any breach of any additional terms and conditions which may be agreed between DAC Beachcroft and/or Bridgetech and User in addition to these Terms.
            </p>
            <p>&emsp;The obligations under the clause 4.6 shall survive the termination or expiration of these Terms.</p>
            <p>
                &emsp;<b>4.7</b> You are responsible for:
            </p>
            <p className="ml-5">
                <b>4.7.1</b> ensuring the suitability of the Platform for your use and needs including compatibility with your mobile device and/or computer system(s);
            </p>
            <p className="ml-5">
                <b>4.7.2</b> obtaining access to the internet in order to use any features of the Platform available online and the Materials contained in it and take advantage of the Permitted Purpose; and
            </p>
            <p>
                &emsp;<b>4.8</b> You acknowledge and agree that:
            </p>
            <p className="ml-5">
                <b>4.8.1</b> we offer no express or implied warranty surrounding the data required for use of the Platform or the speed or functionality that is dependent upon your internet connection;
            </p>
            <p className="ml-5">
                <b>4.8.2</b> the provision of the Platform is carried out via the internet and will involve transmission over various networks operated by and/or owned by third parties. DAC Beachcroft shall not be liable for any loss, corruption, delay or alteration of any Materials in transmission, Uploads or when
                accessed on any computer systems not owned or operated by DAC Beachcroft; and
            </p>
            <p></p>

            <h2>5. Materials on the Platform</h2>
            <p></p>

            <p>
                &emsp;<b>5.1</b> Unless otherwise stated in any additional written terms and conditions which may vary these Terms, any Materials provided on the Platform by DAC Beachcroft are for information purposes only. The Materials must not be used as evidence and do not constitute legal or other advice to any
                person and should not be regarded as a substitute for detailed, separate advice in relation to any matter.
            </p>
            <p>
                &emsp;<b>5.2</b> You warrant and affirm that you have complied with all applicable legal and regulatory requirements concerning any Uploads and ensured that you have all necessary consents, permissions and licenses required to lawfully handle the Upload and use it on the Platform;
            </p>
            <p>
                &emsp;<b>5.3</b> Use of and access to the Platform does not of itself create a solicitor-client relationship between you and DAC Beachcroft and where such a relationship does exist, it is governed by separate terms and conditions of engagement. Where you have separately entered into an agreement or
                undertaking (such as a confidentiality agreement) with DAC Beachcroft relating to the Materials or Uploads then such agreement or undertaking applies in addition to and, in the case of conflict or inconsistency, in priority to these Terms.
            </p>
            <p>
                &emsp;<b>5.4</b> Any Materials provided by DAC Beachcroft are strictly confidential and are being provided to you on the basis that you keep confidential any information contained in them and use such information solely for the Permitted Purpose. The Platform and the Materials may be subject to
                updating, completion, revision, verification and amendment from time to time. No express or implied representation or warranty, is made in relation to, the accuracy or completeness of the Materials contained on the Platform and of the content of the Platform itself. Any liability arising from incorrect,
                incomplete, inaccurate or out of date content of the Materials is, to the fullest extent possible, excluded.
            </p>
            <p>
                &emsp;<b>5.5</b> The Materials do not constitute, or form part of, any offer to sell or issue, or any solicitation of any offer to purchase, acquire, license or subscribe for, any shares or other tangible or intangible property or assets nor shall the Materials or any part of them, or the fact of their
                availability, form the basis of, or be relied on in connection with, any contract for any of the above.
            </p>
            <p>
                &emsp;<b>5.6</b> Where you add, access, view or interact with an Upload for any purpose you acknowledge that this is not created, maintained or approved by DAC Beachcroft and to the fullest extent permitted by law:
            </p>
            <p className="ml-5">
                <b>5.6.1</b> DAC Beachcroft is not responsible for the content, accuracy, veracity, completeness, file stability, or accessibility of the Upload;
            </p>
            <p className="ml-5">
                <b>5.6.2</b> any queries, proposed retention, amendment, variation, or any other issue relating to an Upload should be directed to the party who has control of the Upload and introduced it to the Platform;
            </p>
            <p className="ml-5">
                <b>5.6.3</b> we reserve the right to recover our reasonable administrative, legal and any other associated costs arising from, or relating to, any issue howsoever arising, in relation to an Upload.
            </p>
            <p></p>

            <h2>6. Your Use of the Platform</h2>
            <p></p>

            <p>
                &emsp;<b>6.1</b> You may only use the Platform, Uploads and/or the Materials in the Platform for lawful purposes arising from the ordinary course of business. You may not use the Platform, Uploads and/or the Materials in the Platform:
            </p>
            <p className="ml-5">
                <b>6.1.1</b> as evidence;
            </p>
            <p className="ml-5">
                <b>6.1.2</b> in any way that breaches any applicable local, national or international law or regulation;
            </p>
            <p className="ml-5">
                <b>6.1.3</b> in any way that is unlawful or fraudulent, or has any unlawful or fraudulent purpose or effects;
            </p>
            <p className="ml-5">
                <b>6.1.4</b> to knowingly transmit, send or upload any data or material that contains viruses, trojan horses, worms, time-bombs, keystroke loggers spyware, adware or any other harmful programs or similar computer code designed to adversely affect the operation of any computer software or hardware;
            </p>
            <p className="ml-5">
                <b>6.1.5</b> to store or facilitate the storage or transmission of any illegal content or information; and/or
            </p>
            <p className="ml-5">
                <b>6.1.6</b> to transmit, facilitate, upload, store or otherwise any spam, phishing or other similar activity which in our sole discretion is deemed to be a nuisance to DAC Beachcroft, other users of the Platform, or any third party.
            </p>
            <p className="ml-5">
                <b>6.1.7</b> as a consumer;
            </p>
            <p>
                &emsp;<b>6.2</b> We reserve the right to remove whole or part of any Upload or Material from the Platform at any time and without notice to you.
            </p>
            <p>
                &emsp;<b>6.3</b> We will not be responsible, or liable (howsoever arising) to you or to any third party, for the Materials and/or an Uploads or any material posted on the Platform unless otherwise stated in writing to you or required by law.
            </p>
            <p>
                &emsp;<b>6.4</b> Any Intellectual Property Rights in any external comment or content submitted for use in the Material vests in the IPRO upon publication in the Platform.
            </p>
            <p>
                &emsp;<b>6.5</b> You agree that you will ensure that any Upload is in accordance with the law and our specified file format and size.
            </p>
            <p>
                &emsp;<b>6.6</b> Where you are provided with any additional permissions or rights of access surrounding the Platform for your organisation such permission shall be governed by separate terms and conditions as agreed in writing and signed by DAC Beachcroft.
            </p>
            <p>
                &emsp;<b>6.7</b> You acknowledge that DAC Beachcroft:
            </p>
            <p className="ml-5">
                <b>6.7.1</b> has access to all data including Materials and Uploads used, uploaded, or accessed on the Platform;
            </p>
            <p className="ml-5">
                <b>6.7.2</b> may cause or permit a duly authorised third party access to all or part of the Platform to maintain, upgrade, update or ensure its effective control, operation and functioning;
            </p>
            <p className="ml-5">
                <b>6.7.3</b> does not intend or propose to systematically scrutinise use of the Platform, data, the Uploads or Materials therein but may do so at its sole discretion provided it has commercially reasonable grounds for doing so which may include, but is not limited to, ensuring legal and regulatory
                compliance, confirming compliance with these Terms or such other terms agreed, investigating or understanding any technical or security flaw or concern howsoever brought to our attention.
            </p>
            <p></p>

            <h2>7. Security and Unauthorised Access </h2>
            <p></p>

            <p>
                &emsp;<b>7.1</b> You shall:
            </p>
            <p className="ml-5">
                <b>7.1.1</b> not obtain or attempt to obtain access to the Platform (or to any DAC Beachcroft's and Bridgetech's computer system or network) or to any functionality of the Platform other than that which is available to you through the logins and passwords notified to you by DAC Beachcroft.
            </p>
            <p className="ml-5">
                <b>7.1.2</b> not attempt to evade our authentication or security procedures nor assist, encourage or permit any other person to do any of those things.
            </p>
            <p className="ml-5">
                <b>7.1.3</b> not access, interfere with, damage or disrupt, without authority, any equipment or network on which the Platform is stored, any software used in the provision of the Platform, or any equipment or network or software owned or used by any third party in connection with the Platform.
            </p>
            <p className="ml-5">
                <b>7.1.4</b> promptly notify us of any actual or potential concern which you may identify which relates to this clause 7.1.
            </p>
            <p>
                &emsp;<b>7.2</b> While DAC Beachcroft has taken certain precautions to detect computer viruses and ensure security, we cannot guarantee that the Platform, Uploads and/or the Materials are virus-free and secure and we shall not be liable for any loss or damage which occurs as a result of any virus or
                breach of security.
            </p>
            <p>
                &emsp;<b>7.3</b> You shall protect any device to which the Platform is installed or accessed and your computer systems from exposure to viruses by the use of anti-virus software, firewalls and any other technical measures necessary. DAC Beachcroft gives no warranties as to the compatibility of the
                Platform and/or the Materials with any device, your computer systems, software and/or hardware.
            </p>
            <p>
                &emsp;<b>7.4</b> You must not misuse the Platform by knowingly introducing viruses, trojans, worms, logic bombs or other material which is malicious or technologically harmful. You must not attack the Platform via a denial-of-service attack or a distributed denial-of-service attack.
            </p>
            <p>
                &emsp;<b>7.5</b> We may be obliged to report any breach of this clause 7 to the relevant law enforcement authorities and we will co-operate with those authorities by disclosing your identity to them. In the event of such a breach, your right to use the Platform will cease immediately (regardless of any
                notification made to relevant law enforcement authorities).
            </p>
            <p>
                &emsp;<b>7.6</b> We shall not be liable for any loss or damage caused by a distributed denial-of-service attack, viruses or other technologically harmful material that may infect your device, computer equipment, computer programs, data or other proprietary material due to your use of the Platform or to
                your downloading of any material posted on it, or on any website linked to it.
            </p>
            <p></p>

            <h2>8. Availability </h2>
            <p></p>

            <p>
                &emsp;<b>8.1</b> DAC Beachcroft reserves the right at any time to without notice:
            </p>
            <p className="ml-5">
                <b>8.1.1</b> modify or discontinue, temporarily take down or permanently delete, the Platform, any of the Materials and/or Uploads;
            </p>
            <p className="ml-5">
                <b>8.1.2</b> restrict, suspend or remove your access to the Platform or any login or password;
            </p>
            <p className="ml-5">
                <b>8.1.3</b> modify, discontinue, or enhance any element of the Platform;
            </p>
            <p>
                &emsp;<b>8.2</b> We may update the Platform and change the content at any time. If the need arises we may suspend access to the Platform or close it indefinitely.
            </p>
            <p>
                &emsp;<b>8.3</b> You acknowledge that:
            </p>
            <p className="ml-5">
                <b>8.3.1</b> any of the Uploads or Materials on the Platform may be out of date at any given time and DAC Beachcroft is:
            </p>
            <p className="ml-5 pl-5">
                <b>(i)</b> under no obligation to update the Materials; and
            </p>
            <p className="ml-5 pl-5">
                <b>(ii)</b> are not responsible for the updating or maintenance of any Upload.
            </p>
            <p className="ml-5">
                <b>8.3.2</b> DAC Beachcroft are not responsible for and do not guarantee any third party availability, coverage, uptime or compatibility with any telephone or other communications network, computer or mobile telephone operating system or version,
            </p>
            <p>
                &emsp;<b>8.4</b> DAC Beachcroft shall have no liability to you for any loss or damage whatsoever in respect of any action we take pursuant to this clause, or if for any reason the Platform is unavailable at any time or for any period.
            </p>
            <p></p>

            <h2>9. Monitoring </h2>
            <p></p>

            <p>
                &emsp;<b>9.1</b> DAC Beachcroft reserve the right to monitor your use of the Platform, the Credit Hire Services and the pages Uploads and Materials viewed and used (<b>“Monitoring”</b>).
            </p>
            <p>
                &emsp;<b>9.2</b> Where any Monitoring is undertaken it shall be for the purpose of understanding the level of use of the Platform and the Credit Hire Services and/or Legal Services by you and other users to support the provision of the Platform and any related activities arising from usage. Such details
                will be in accordance with our{' '}
                <a href="https://www.dacbeachcroft.com/en/gb/about/privacy-policy/" target="_blank">
                    Privacy Policy
                </a>{' '}
                and{' '}
                <a href="https://www.dacbeachcroft.com/en/gb/about/cookies/" target="_blank">
                    Cookie Policy
                </a>{' '}
                available on the DAC Beachcroft{' '}
                <a href="https://www.dacbeachcroft.com/en/gb/" target="_blank">
                    website
                </a>{' '}
                .
            </p>
            <p></p>

            <h2>10. Intellectual Property Rights </h2>
            <p></p>

            <p>
                &emsp;<b>10.1</b> The DAC Beachcroft and Bridgetech are the owners or the licensees of all intellectual property rights in the Platform. Those works are protected by copyright laws and treaties around the world. All such rights are reserved.
            </p>
            <p>
                &emsp;<b>10.2</b> It is your responsibility to inform yourself as to the legal protection afforded to the Uploads and Materials. Beyond the rights expressly given you by these Terms in the section headed “Your Use of the Platform” Parties does not grant any express or implied licence or other right to
                you with respect to the Materials or any Upload. This does not affect any rights you may otherwise have to possess, use, copy or otherwise deal with any Upload or the Materials.
            </p>
            <p></p>

            <h2>11. Data Protection </h2>
            <p></p>

            <p>
                &emsp;<b>11.1</b> DAC Beachcroft is committed to protecting the data of everyone we deal with. This clause 11 sets out important information about how DAC Beachcroft may collect and use your data. It also sets out how we will deal with you to ensure that our respective roles and responsibilities are
                reflected. User's personal data will be processed according to the DAC Beachcroft’s{' '}
                <a href="https://www.dacbeachcroft.com/en/mx/about/privacy-policy/" target="_blank">
                    Privacy Policy
                </a>{' '}
                .
            </p>
            <p>
                &emsp;<b>11.2</b> For the purpose of this clause, the following expressions shall have the following meanings:
            </p>
            <table border="0">
                <tbody>
                    <tr>
                        <td>
                            <p>
                                <b>"Data Controller"</b>, <b>"Data Subject"</b>, <b>"Personal Data"</b>, <b>"Process"</b>, <b>"Processed"</b>, <b>"Processing"</b> or <b>"Processes"</b>
                            </p>
                        </td>
                        <td>
                            <p>have the meaning given in the Data Protection Legislation;</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>
                                <b>"Data Protection Legislation"</b>
                            </p>
                        </td>
                        <td>
                            <p>means all data protection and privacy legislation, regulations and guidance applicable in respect of a Party from time to time including, but not limited to:</p>
                            <p className="ml-5">
                                <b>(i)</b> the EU and UK General Data Protection Regulation;
                            </p>
                            <p className="ml-5">
                                <b>(ii)</b> other relevant UK and EU legislation (such as the Privacy and Electronic Communications (EC Directive) Regulations 2003);
                            </p>
                            <p className="ml-5">
                                <b>(iii)</b> our regulatory obligations and professional duty of privilege and confidentiality;
                            </p>
                            <p className="ml-5">
                                <b>(iv)</b> applicable guidance and rulings issued by applicable legal and regulatory bodies (including but not limited to the Information Commissioner’s Office, the European Data Protection Board, any other Regulator);
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>
                                <b>"Security Breach"</b>
                            </p>
                        </td>
                        <td>
                            <p>
                                means an actual, suspected or threatened event that affects the confidentiality, integrity, availability and/or resilience of the Shared Data, the systems on which it is Processed, and/or the services through which it is accessed, including (without limitation) a 'personal data breach'
                                as defined in Data Protection Legislation; and
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>
                                <b>“Shared Data”</b>
                            </p>
                        </td>
                        <td>
                            <p>means any Personal Data held by one party as a Data Controller, which is provided to the other party as a Data Controller under these Terms.</p>
                        </td>
                    </tr>
                </tbody>
            </table>
            <p>
                &emsp;<b>11.3</b> The Parties acknowledge that in respect of the Shared Data each is a separate Data Controller; one will be the recipient and the other the discloser.
            </p>
            <p>
                &emsp;<b>11.4</b> Each party shall Process the Shared Data in accordance with the Data Protection Legislation.
            </p>
            <p>
                &emsp;<b>11.5</b> In relation to the Shared Data, the discloser shall ensure that:
            </p>
            <p className="ml-5">
                <b>11.5</b> the Shared Data has been obtained by it and transferred to the recipient, in accordance with the Data Protection Legislation;
            </p>
            <p className="ml-5">
                <b>11.5</b> the Shared Data is accurate and up to date; and
            </p>
            <p className="ml-5">
                <b>11.5</b> it has provided the Data Subjects of the Shared Data with a fair processing notice in accordance with the Data Protection Legislation, which allows it to transfer the Shared Data to the recipient and allows the recipient to Process the Shared Data. DAC Beachcroft’s Privacy Policy can be
                found{' '}
                <a href="https://www.dacbeachcroft.com/en/gb/about/privacy-policy/" target="_blank">
                    here
                </a>{' '}
                .
            </p>
            <p>
                &emsp;<b>11.6</b> In relation to the Shared Data, the recipient shall:
            </p>
            <p className="ml-5">
                <b>11.6.1</b> comply with the Data Protection Legislation;
            </p>
            <p className="ml-5">
                <b>11.6.2</b> implement, maintain and regularly test, appropriate technical and organisational measures to protect the Shared Data from a Security Breach;
            </p>
            <p className="ml-5">
                <b>11.6.3</b> provide the Data Subjects of the Shared Data with a fair processing notice in accordance with the Data Protection Legislation; and
            </p>
            <p className="ml-5">
                <b>11.6.4</b> where necessary under the Data Protection Legislation, obtain the consent of the Data Subjects to Processing of the Shared Data.
            </p>
            <p>
                &emsp;<b>11.7</b> In the event of a Security Breach in respect of the Shared Data Processed by (or on behalf of) the recipient, the recipient shall handle such Security Breach in accordance with the Data Protection Legislation and shall notify the discloser as soon as reasonably practicable, and in any
                event at least 24 hours before notifying any applicable regulator or any Data Subject.
            </p>
            <p>
                &emsp;<b>11.8</b> Each party shall promptly notify the other party if it becomes aware of any circumstance which may cause either party to breach:
            </p>
            <p className="ml-5">
                <b>11.8.1</b> These Terms in relation to the Shared Data; and/or
            </p>
            <p className="ml-5">
                <b>11.8.2</b> the Data Protection Legislation in relation to the Shared Data.
            </p>
            <p>
                &emsp;<b>11.9</b> Each party shall promptly notify the other party as soon as it receives any request or enquiry from any applicable regulator or Data Subject with regard to the Shared Data, and shall keep the other party regularly updated as to how it handles such request or enquiry.
            </p>
            <p>
                &emsp;<b>11.10</b> Each party shall reasonably cooperate with the other party concerning:
            </p>
            <p className="ml-5">
                <b>11.10.1</b> the other party’s compliance with these Terms in relation to the Shared Data;
            </p>
            <p className="ml-5">
                <b>11.10.2</b> the other party’s compliance with the Data Protection Legislation in relation to the Shared Data; and/or
            </p>
            <p className="ml-5">
                <b>11.10.3</b> any request or investigation by any applicable regulator regarding the Shared Data.
            </p>
            <p>
                &emsp;<b>11.11</b> The Parties agree that DAC Beachcroft may subcontract some operational functions to comply with its obligations under these Terms.
            </p>
            <p>
                &emsp;<b>11.12</b> You acknowledge that DAC Beachcroft uses third party service providers (including ‘cloud’ service providers) to help it deliver efficient, cost effective legal services. This may include document/information hosting, sharing, transfer, analysis, processing or storage. DAC Beachcroft
                ensure all third party service providers operate under service agreements that are consistent with our legal and professional obligations, including in relation to confidentiality, privacy and data protection.
            </p>
            <p>
                &emsp;<b>11.13</b> DAC Beachcroft may transfer personal data outside of the UK and the EEA. If so, DAC Beachcroft shall ensure that any such export complies with the provisions of the Data Protection Legislation and any other applicable Laws (and such data transfer agreements as may be required are
                entered in to ensure that such processing or disclosure complies with all relevant Data Protection Legislation) which may include the UK international transfer agreement/addendum and/or EU standard contractual clauses.
            </p>
            <p>
                &emsp;<b>11.14</b> You will be liable to DAC Beachcroft and shall indemnify us for any breach of warranty.
            </p>
            <p></p>

            <h2>12. Our Liability </h2>
            <p></p>

            <p>
                &emsp;<b>12.1</b> The express provisions of these Terms are in place of all warranties, conditions, terms, undertakings and obligations implied by statute, common law, custom, trade usage, course of dealing or otherwise, all of which are excluded to the fullest extent permitted by law. In particular,
                DAC Beachcroft does not warrant that the operation of the Platform will be uninterrupted or error-free, nor that the Materials on the Platform are complete or accurate.
            </p>
            <p>
                &emsp;<b>12.2</b> DAC Beachcroft shall not be liable for any:
            </p>
            <p className="ml-5">
                <b>12.2.1</b> consequential or indirect loss or damage;
            </p>
            <p className="ml-5">
                <b>12.2.2</b> loss of profit or contracts;
            </p>
            <p className="ml-5">
                <b>12.2.3</b> loss of goodwill;
            </p>
            <p className="ml-5">
                <b>12.2.4</b> loss of data;
            </p>
            <p className="ml-5">
                <b>12.2.5</b> loss of anticipated savings;
            </p>
            <p className="ml-5">
                <b>12.2.6</b> wasted management time, or
            </p>
            <p className="ml-5">
                <b>12.2.7</b> business or economic loss,
            </p>
            <p>arising out of the use of or inability to use the Platform (or any part or function relating to the same) or the provision of or failure to provide any of the Permitted Purpose. </p>
            <p>
                &emsp;<b>12.3</b> DAC Beachcroft shall not be liable for any loss or damage whatsoever (including direct loss) resulting from your use of the Platform other than in accordance with these Terms.
            </p>
            <p>
                &emsp;<b>12.4</b> Subject to the final paragraph of this section and without prejudice to the preceding paragraphs of this section or any regulatory minimum requirement, DAC Beachcroft's liability to you arising in connection with the Platform (whether the liability arises for breach of contract,
                negligence, or otherwise) shall be limited to £5,000,000 (five million pounds).
            </p>
            <p>
                &emsp;<b>12.5</b> In consideration of you being provided with access to the Platform, you agree that these Terms, and in particular the limits on DAC Beachcroft's liability and obligations, are fair and reasonable.
            </p>
            <p>
                &emsp;<b>12.6</b> Save for deliberate, malicious or illegal acts, or breach of or liability arising under these Terms, your liability to us shall be limited to £1 (one pound).
            </p>
            <p>
                &emsp;<b>12.7</b> Nothing in these Terms shall exclude or limit (even if any other term of the Agreement would suggest otherwise) either Party’s liability for death or personal injury caused by their negligence, for fraud or fraudulent misrepresentation, or for any other liability which cannot be
                legally excluded or limited.
            </p>
            <p></p>

            <h2>13. Variations </h2>
            <p></p>

            <p>
                We may revise these Terms (available at:{' '}
                <Link to={window.location.href} target={"_blank"}>{window.location.href}</Link>
                ) at any time without notice.
            </p>
            <p></p>

            <h2>14. General </h2>
            <p></p>

            <p>
                &emsp;<b>14.1</b> If any provision of these Terms, or any part of a provision of these Terms, is found to be illegal, invalid or unenforceable the remaining provisions, or the remainder of the provision concerned, shall continue in effect.
            </p>
            <p>
                &emsp;<b>14.2</b> These terms constitute the entire agreement between the parties and supersedes and extinguishes all previous agreements, promises, assurances, warranties, representations and understandings between us and you, whether oral or written, relating to its subject matter.
            </p>
            <p>
                &emsp;<b>14.3</b> A failure or delay by DAC Beachcroft in enforcing compliance with any provision of these Terms shall not be a waiver of that or any other provision of these Terms.
            </p>
            <p>
                &emsp;<b>14.4</b> None of these Terms shall be enforceable under the Contracts (Rights of Third Parties) Act 1999 by any third party, except for Bridgetech where Bridgetech's rights are infringed or affected by your breach of these Terms. Bridgetech shall have the rights to enforce these terms directly
                against you at its own capacity.
            </p>
            <p>
                &emsp;<b>14.5</b> The headings used in these Terms are for convenience only and shall not affect interpretation.
            </p>
            <p>
                &emsp;<b>14.6</b> In these Terms, unless specified to the contrary, use of the singular is deemed to include the plural and vice versa, use of any gender is deemed to include every gender, and any reference to a person is deemed to include a corporation, a partnership and any other body or entity.
            </p>
            <p>
                &emsp;<b>14.7</b> In these Terms any phrase introduced by the terms “including”, “include”, “in particular” or any similar expression shall be construed as illustrative and shall not limit the sense of the words preceding those terms.
            </p>
            <p></p>

            <h2>15. Governing Law and Jurisdiction </h2>
            <p></p>

            <p>
                &emsp;<b>15.1</b> The English courts will have exclusive jurisdiction over any claim arising from, or related to, access to or use of the Platform or to these Terms although DAC Beachcroft and/or Bridgetech retain the right to bring proceedings against you for breach of these Terms in your country of
                residence or any other relevant country.
            </p>
            <p>
                &emsp;<b>15.2</b> These Terms and any dispute or claim arising out of or in connection with them or their subject matter or formation or in connection with the Platform (including non-contractual disputes or claims) shall be governed by and construed in accordance with the law of England and Wales.
            </p>
        </div>
    );

    return isAuthenticated() ? (
        <PageLayout>{pageContent}</PageLayout>
    ) : (
        <PublicPageLayout>
            <Card>{pageContent}</Card>
        </PublicPageLayout>
    );
};

export default TermsConditionsPage;
